/** World events → effects: Life outside the fight: barks, rewards, loot, training, school and quests. Moved verbatim from Effects.handle (render/effects.ts). */

import { registerFxEvent } from './registry';

registerFxEvent('bark', (host, ev, _w) => {
  host.bubbles.set(ev.id, { text: ev.text, t: 0 });
});

registerFxEvent('reward', (host, ev, w) => {
  const e = w.get(ev.id);
  if (!e) return;
  const [x, y] = host.pos(e);
  host.texts.push({
    x,
    y: y - 30 * e.scale,
    text: `+${ev.gold} ตำลึง  +${ev.cultivation} ฝึกปรือ`,
    color: '#f2d27a',
    size: 13,
    t: 0,
    life: 1.4,
  });
  host.sfx.coin();
});

registerFxEvent(['respawn', 'meditate'], (host, ev, w) => {
  if (ev.type === 'meditate' && !ev.on) return;
  const [x, y] = host.pos(w.player);
  host.fx.push({ type: 'ring', x, y, t: 0, life: 0.7, r: 26, col: '120,230,190' });
  if (ev.type === 'meditate')
    host.fx.push({ type: 'sigil', x, y, t: 0, life: 1.2, r: 20, col: '150,240,200' });
});

registerFxEvent('loot', (host, ev, w) => {
  const m = w.get(ev.id);
  if (!m) return;
  const [x, y] = host.pos(m);
  host.fx.push({ type: 'pillar', x, y, t: 0, life: 1, col: '255,214,120' });
  host.fx.push({ type: 'star', x, y: y - 10, t: 0, life: 0.35, r: 14, col: '255,230,150' });
  host.burst(x, y - 8, 18, ['#ffe39a', '#fff4cf', '#f2c45a'], 50, 50, 0.8);
  host.sfx.coin();
});

registerFxEvent('equipped', (host, _ev, w) => {
  const [x, y] = host.pos(w.player);
  host.fx.push({ type: 'ring', x, y, t: 0, life: 0.5, r: 22, col: '255,220,140' });
  host.burst(x, y - 20, 10, ['#ffe39a', '#ffffff'], 40, 30, 0.5);
});

registerFxEvent(['joinedSchool', 'learnedArt'], (host, ev, w) => {
  const [x, y] = host.pos(w.player);
  host.fx.push({
    type: 'pillar',
    x,
    y,
    t: 0,
    life: 1.4,
    col: ev.type === 'joinedSchool' ? '230,236,248' : '255,220,120',
  });
  host.fx.push({ type: 'yinyang', x, y, t: 0, life: 1.4, r: 26 });
  host.sfx.train();
});

registerFxEvent('trained', (host, ev, w) => {
  const [x, y] = host.pos(w.player);
  host.fx.push({
    type: 'pillar',
    x,
    y,
    t: 0,
    life: 1.2,
    col: ev.what === 'neigong' ? '140,220,255' : '255,220,120',
  });
  host.fx.push({
    type: 'sigil',
    x,
    y,
    t: 0,
    life: 1.2,
    r: 24,
    col: ev.what === 'neigong' ? '140,220,255' : '255,220,120',
  });
  host.burst(x, y - 10, 24, ['#ffe39a', '#fff4cf', '#f2c45a'], 50, 60, 1);
  host.sfx.train();
});

registerFxEvent('quest', (host, ev, w) => {
  if (ev.status === 'completed') {
    const [x, y] = host.pos(w.player);
    host.fx.push({ type: 'pillar', x, y, t: 0, life: 1.3, col: '255,220,120' });
    host.sfx.train();
  }
});
